Vendd.Scripts.load(function () {

    initSocialShare = function () {

        var $wrappers = $('.js-share-buttons-two');

        $wrappers.each(function () {
            var $wrapper = $(this);
            $wrapper.attr("social-setup", true);

            if ($wrapper.hasClass('initialized')) {
                return;
            } else {
                $wrapper.addClass('initialized');
            }

            var linkUrl = window.location.origin + $wrapper.data("url");

            if (typeof $wrapper.data('facebook') !== 'undefined') {
                var facebookUrl = "http://api.addthis.com/oexchange/0.8/forward/facebook/offer?pco=tbx32nj-1.0&url={{Url}}";
                facebookUrl = facebookUrl.replace("{{Url}}", linkUrl);
                $wrapper.append($("<li>").append($("<a>").addClass("facebook icon-facebook").attr("href", facebookUrl).attr("target", "_blank").attr("rel", "noopener").append($("<span>").addClass("text").text('facebook'))));
            }

            if (typeof $wrapper.data('twitter') !== 'undefined') {
                var twitterUrl = "http://api.addthis.com/oexchange/0.8/forward/twitter/offer?pco=tbx32nj-1.0&url={{Url}}";
                twitterUrl = twitterUrl.replace("{{Url}}", linkUrl);
                $wrapper.append($("<li>").append($("<a>").addClass("twitter icon-twitter").attr("href", twitterUrl).attr("target", "_blank").attr("rel", "noopener").append($("<span>").addClass("text").text('twitter'))));
            }

            if (typeof $wrapper.data('pinterest') !== 'undefined') {
                var pinterestUrl = "http://api.addthis.com/oexchange/0.8/forward/pinterest_share/offer?pco=tbx32nj-1.0&url={{Url}}";
                pinterestUrl = pinterestUrl.replace("{{Url}}", linkUrl);
                $wrapper.append($("<li>").append($("<a>").addClass("pinterest icon-pinterest").attr("href", pinterestUrl).attr("target", "_blank").attr("rel", "noopener").append($("<span>").addClass("text").text('pinterest'))));
            }

            if (typeof $wrapper.data('email') !== 'undefined') {
                var forwardEmail = "http://api.addthis.com/oexchange/0.8/forward/email/offer?pco=tbx32nj-1.0&url={{Url}}";
                forwardEmail = forwardEmail.replace("{{Url}}", linkUrl);
                $wrapper.append($("<li>").append($("<a>").addClass("email icon-mail").attr("href", forwardEmail).attr("target", "_blank").attr("rel", "noopener").append($("<span>").addClass("text").text('mail'))));
            }

        });

    }
    initSocialShare();
});